import { useQuery } from "@tanstack/react-query";
import { getMetadataTagsList } from "../api/getMetadataTagsList";
import { queryClient } from "shared/api/queryClient";

export const QUERY_KEY = "metadata-tags";

export const useMetadataTagsListQuery = () => {
  return useQuery({
    queryKey: [QUERY_KEY],
    queryFn: getMetadataTagsList,
  });
};

export const invalidateMetadataTagListQuery = () => {
  return queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
};
